// Initialize popovers because Bootstrap doesn't do it itself

import { Popover } from 'bootstrap'

new Popover(document.body, {
  selector: '[data-bs-toggle="popover"]', // This allows to use popovers for dymanic content too
  trigger: 'focus', // Dismiss popovers on click
  html: true,
})
